import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';
import { useFieldBorder } from '@/common/customisation/composables/useFieldBorder';

/**
 * Composable for Widget Input component customisation
 * Returns input field styling and content configuration
 */
export const useWidgetInputCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey: PUI.HOME_SECTION_KEYS.INPUT_FIELD,
    blockKey: PUI.HOME_BLOCK_KEYS.CHATBOT_SECTION,
  });

  const placeholderText = getField(PUI.COMMON_FIELD_KEYS.PLACEHOLDER_TEXT);
  const placeholderColor = getField(PUI.COMMON_FIELD_KEYS.PLACEHOLDER_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const actionColor = getField(PUI.COMMON_FIELD_KEYS.ACTION_COLOR);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    placeholderText,
    placeholderColor,
    backgroundColor,
    actionColor,
    borderColor,
  };
};
